export default class {

    PhotoList = [];

    mapFromDto(photoListDto) {
        this.PhotoList = photoListDto.map(e => new Photo().mapFromDto(e));

        return this;
    }

}

class Photo {

    Id = null;    

    Url = null;

    Category = null;    
    
    Comment = null;  

    Location = null;

    CreationDate = null;

    IsReadOnlyCategory = false;

    mapFromDto(photoDto) {

        this.Id = photoDto.Id;
        this.Url = photoDto.Url;
        this.Category = photoDto.Category;
        this.Comment = photoDto.Comment;
        this.Location = photoDto.Location;        
        this.CreationDate = photoDto.CreationDate;   
        this.IsReadOnlyCategory = photoDto.IsReadOnlyCategory;    

        return this;
    }
}